import { EmployeeScheduleCalendar } from '../Components/EmployeeScheduleCalendar';
import { type ReactElement } from 'react';

export const EmployeeTimeTableSection = (): ReactElement => {
  return <EmployeeScheduleCalendar allowMonthSwitching />;
};
